import { render } from "./NavigationBottom.vue?vue&type=template&id=01eba1e2&lang=html"
import script from "./NavigationBottom.vue?vue&type=script&lang=js"
export * from "./NavigationBottom.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__